import React from "react";
import Select from "react-select";
import { CDBBtn, CDBSpinner } from "cdbreact";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Swal from 'sweetalert2';
import dayjs from "dayjs";

export const ModalReports = ({
  action,
  setPressedButton,
  formData,
  handleChange,
  isLoading,
  skus,
  receptions,
  origin,
  providers
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  const isCreateAction = action === "create";

  const skusSelect = skus.map((sku) => ({
    value: sku.CodeSap,
    label: `${sku.CodeSap} - ${sku.SkuDescription}`,
  }));

  const providerSelect = providers.map((provider) => ({
    value: provider.Nit,
    label: `Código Proveedor: ${provider.Nit} / Nombre del proyecto: ${provider.ProjectName}`,
  }));

  const receptionsSelect =
    (origin === "RECEPTION" ||
      origin === "QUALITYS" ||
      origin === "DOCUMENT") &&
    receptions.map((reception) => ({
      value: reception.LotNumber,
      label: `${reception.LotNumber.split("/*-/")[0]} - ${reception.CodeSap}`,
    }));

  const commonOptions = [
    { value: "TimeStart", label: "Fecha Inicial" },
    { value: "TimeEnd", label: "Fecha Final" },
    { value: "selectedProvider", label: "Código de Proveedor" },
  ];

  const skusOptions = [
    ...commonOptions,
    { value: "selectedCodeSap", label: "Código SAP" },
    { value: "smallerThanRop", label: "ROP Menor que" },
    { value: "greaterThanRop", label: "ROP Mayor que" },
    { value: "smallerThanCantidadEnvio", label: "Cantidad de Envío Menor que" },
    { value: "greaterThanCantidadEnvio", label: "Cantidad de Envío Mayor que" },
    {
      value: "smallerThanPorcentajeInventario",
      label: "Porcentaje de Inventario Menor que",
    },
    {
      value: "greaterThanPorcentajeInventario",
      label: "Porcentaje de Inventario Mayor que",
    },
  ];

  const receptionOptions = [
    ...commonOptions,
    { value: "selectedCodeSap", label: "Filtrar por Código SAP" },
    { value: "selectedLote", label: "Filtrar por Nº de lote" },
    {
      value: "smallerThanUnidadesRecibidas",
      label: "Unidades Recibidas Menor que",
    },
    {
      value: "greaterThanUnidadesRecibidas",
      label: "Unidades Recibidas Mayor que",
    },
    {
      value: "smallerThanUnidadesDefectuosas",
      label: "Unidades Defectuosas Menor que",
    },
    {
      value: "greaterThanUnidadesDefectuosas",
      label: "Unidades Defectuosas Mayor que",
    },
  ];

  const documentOptions = [
    ...commonOptions,
    { value: "selectedCodeSap", label: "Código SAP" },
    { value: "selectedLote", label: "Nº de lote" },
    {
      value: "selectedReceipt",
      label: "Factura",
    },
    {
      value: "selectedRemission",
      label: "por Remisión",
    },
    {
      value: "selectedQualityCertificate",
      label: "Certificado de Calidad",
    },
    {
      value: "selectedSafetySheet",
      label: "Hoja de Seguridad",
    },
    {
      value: "smallerThanPorcentajeDoc",
      label: "Porcentaje de documentos Menor que",
    },
    {
      value: "greaterThanPorcentajeDoc",
      label: "Porcentaje de documentos Mayor que",
    },
  ];

  const providerInventoryOptions = [
    { value: "TimeStart", label: "Fecha Inicial" },
    { value: "TimeEnd", label: "Fecha Final" },
    { value: "selectedProviders", label: "Proveedores (Múltiples)" },
    { value: "onlyActive", label: "Solo SKUs Activos" },
  ];

  const options =
    origin === "SKUS"
      ? skusOptions
      : origin === "RECEPTION" || origin === "QUALITYS"
      ? receptionOptions
      : origin === "DOCUMENT"
      ? documentOptions
      : origin === "PROVIDER_INVENTORY"
      ? providerInventoryOptions
      : [];

  const stateDocumentOptions = [
    { value: "Si", label: "Si" },
    { value: "No", label: "No" },
    { value: "No Aplica", label: "No Aplica" },
  ];

  const handleOptionChange = (selected) => {
    const selectedValues = selected.map((item) => item.value);
    setSelectedOptions(selectedValues);
    handleChange({ target: { value: selectedValues, id: "selectedOptions" } });
  };

  const handleInfoButtonClick = () => {
    Swal.fire({
      title: 'Guía de Filtros',
      html:
        '<p style="text-align: justify;">Seleccione los filtros que necesite para personalizar su búsqueda. Tenga en cuenta que al agregar más filtros, la información puede ser más limitada.</p>' +
        '<ol style="text-align: justify;">' +
        '  <li><strong>Por Fecha:</strong> Utilice la fecha inicial y/o final para consultar registros en un rango específico.</li>' +
        '  <li><strong>Por Códigos Únicos:</strong> Elija un código SAP, número de lote u otro código único para ver los registros asociados.</li>' +
        '  <li><strong>Por Datos:</strong> Aplique filtros para valores específicos, ya sea "menor que", "mayor que" o en un rango determinado.</li>' +
        '  <li><strong>Por Estados:</strong> Útil para la gestión documental, filtre por disponibilidad, no disponibilidad o casos donde no aplica.</li>' +
        '</ol>',
      icon: 'info',
      confirmButtonText: 'Entendido',
      confirmButtonColor: '#146284',
      footer: '¡Gracias por utilizar nuestros filtros para una búsqueda más precisa!'
    });
  };

  return (
    <div>
      <style>
      {`
          .btn-info {
            background-color: #007bff;
            color: #ffffff;
          }
          
          .btn-info .fas.fa-info-circle {
            color: #ffffff;
          }
      `}
      </style>
      <div className="modal-header">
        <div>
          <h3 className="modal-title" id="exampleModalLabel">
            Generar un reporte
          </h3>
        </div>
        <Button variant="info" onClick={handleInfoButtonClick}>
          <i className="fas fa-info-circle"></i> Información
        </Button>
      </div>

      <div className="modal-body">
        <div className="form-group row mb-4">
          <div className="col">
            <label htmlFor="selectType">Seleccionar un filtro:</label>
            <Select
              options={options}
              placeholder="Seleccione un filtro"
              isMulti
              value={options.filter((option) =>
                selectedOptions.includes(option.value)
              )}
              onChange={handleOptionChange}
            />
          </div>
        </div>

        {selectedOptions.includes("TimeStart") && (
          <div>
            <div className="form-group row">
              <div className="col">
                <label htmlFor="dateStart">Fecha inicial:</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      className="form-control mb-4"
                      id="TimeStart"
                      format="DD/MM/YYYY"
                      value={formData.TimeStart}
                      onChange={(date) =>
                        handleChange({
                          target: { value: date, id: "TimeStart" },
                        })
                      }
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
            </div>
          </div>
        )}

        {selectedOptions.includes("TimeEnd") && (
          <div>
            <div className="col">
              <label htmlFor="dateEnd">Fecha final:</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    className="form-control mb-4"
                    id="TimeEnd"
                    format="DD/MM/YYYY"
                    value={formData.TimeEnd}
                    onChange={(date) =>
                      handleChange({
                        target: { value: date, id: "TimeEnd" },
                      })
                    }
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>
          </div>
        )}

        {selectedOptions.includes("selectedProvider") && (
          <div>
            <div className="form-group row mb-4">
              <div className="col">
                <label htmlFor="selectedProvider">Seleccionar Proveedor:</label>
                <Select
                  id="selectedProvider"
                  placeholder="Seleccione un Proveedor"
                  options={providerSelect}
                  value={providerSelect.find(
                    (option) => option.value === formData.selectedCodeSap
                  )}
                  onChange={(selectedOption) =>
                    handleChange({
                      target: {
                        value: selectedOption.value,
                        id: "selectedProvider",
                      },
                    })
                  }
                />
              </div>
            </div>
          </div>
        )}

        {selectedOptions.includes("selectedCodeSap") && (
          <div>
            <div className="form-group row mb-4">
              <div className="col">
                <label htmlFor="selectCodeSap">Seleccionar Código SAP:</label>
                <Select
                  id="selectCodeSap"
                  placeholder="Seleccione un Código SAP"
                  options={skusSelect}
                  value={skusSelect.find(
                    (option) => option.value === formData.selectedCodeSap
                  )}
                  onChange={(selectedOption) =>
                    handleChange({
                      target: {
                        value: selectedOption.value,
                        id: "selectedCodeSap",
                      },
                    })
                  }
                />
              </div>
            </div>
          </div>
        )}

        {selectedOptions.includes("selectedLote") && (
          <div className="form-group row mb-4">
            <div className="col">
              <label htmlFor="selectLote">Seleccionar Nº de lote:</label>
              <Select
                placeholder="Seleccione un lote"
                id="selectLote"
                options={receptionsSelect}
                value={receptionsSelect.find(
                  (option) => option.value === formData.selectedLote
                )}
                onChange={(selectedOption) =>
                  handleChange({
                    target: {
                      value: selectedOption.value,
                      id: "selectedLote",
                    },
                  })
                }
              />
            </div>
          </div>
        )}

        {origin === "SKUS" && (
          <>
            {selectedOptions.includes("smallerThanRop") && (
              <div>
                <div className="form-group row">
                  <div className="col">
                    <label htmlFor="smallerThanRop">ROP menor que:</label>
                    <input
                      type="number"
                      className="form-control mb-4"
                      id="smallerThanRop"
                      value={formData.smallerThanRop}
                      onChange={(e) =>
                        handleChange({
                          target: {
                            value: e.target.value,
                            id: "smallerThanRop",
                          },
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            )}

            {selectedOptions.includes("greaterThanRop") && (
              <div>
                <div className="form-group row">
                  <div className="col">
                    <label htmlFor="greaterThanRop">ROP mayor que:</label>
                    <input
                      type="number"
                      className="form-control mb-4"
                      id="greaterThanRop"
                      value={formData.greaterThanRop}
                      onChange={(e) =>
                        handleChange({
                          target: {
                            value: e.target.value,
                            id: "greaterThanRop",
                          },
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            )}

            {selectedOptions.includes("smallerThanCantidadEnvio") && (
              <div>
                <div className="form-group row">
                  <div className="col">
                    <label htmlFor="smallerThanCantidadEnvio">
                      Cantidad de Envío Menor que:
                    </label>
                    <input
                      type="number"
                      className="form-control mb-4"
                      id="smallerThanCantidadEnvio"
                      value={formData.smallerThanCantidadEnvio}
                      onChange={(e) =>
                        handleChange({
                          target: {
                            value: e.target.value,
                            id: "smallerThanCantidadEnvio",
                          },
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            )}

            {selectedOptions.includes("greaterThanCantidadEnvio") && (
              <div>
                <div className="form-group row">
                  <div className="col">
                    <label htmlFor="greaterThanCantidadEnvio">
                      Cantidad de Envío Mayor que:
                    </label>
                    <input
                      type="number"
                      className="form-control mb-4"
                      id="greaterThanCantidadEnvio"
                      value={formData.greaterThanCantidadEnvio}
                      onChange={(e) =>
                        handleChange({
                          target: {
                            value: e.target.value,
                            id: "greaterThanCantidadEnvio",
                          },
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            )}

            {selectedOptions.includes("smallerThanPorcentajeInventario") && (
              <div>
                <div className="form-group row">
                  <div className="col">
                    <label htmlFor="smallerThanPorcentajeInventario">
                      Porcentaje de Inventario Menor que:
                    </label>
                    <input
                      type="number"
                      className="form-control mb-4"
                      id="smallerThanPorcentajeInventario"
                      value={formData.smallerThanPorcentajeInventario}
                      onChange={(e) =>
                        handleChange({
                          target: {
                            value: e.target.value,
                            id: "smallerThanPorcentajeInventario",
                          },
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            )}

            {selectedOptions.includes("greaterThanPorcentajeInventario") && (
              <div>
                <div className="form-group row">
                  <div className="col">
                    <label htmlFor="greaterThanPorcentajeInventario">
                      Porcentaje de Inventario Mayor que:
                    </label>
                    <input
                      type="number"
                      className="form-control mb-4"
                      id="greaterThanPorcentajeInventario"
                      value={formData.greaterThanPorcentajeInventario}
                      onChange={(e) =>
                        handleChange({
                          target: {
                            value: e.target.value,
                            id: "greaterThanPorcentajeInventario",
                          },
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {(origin === "RECEPTION" || origin === "QUALITYS") && (
          <>
            {selectedOptions.includes("smallerThanUnidadesRecibidas") && (
              <div className="form-group row">
                <div className="col">
                  <label htmlFor="smallerThanUnidadesRecibidas">
                    Unidades recibidas Menor que:
                  </label>
                  <input
                    type="number"
                    className="form-control mb-4"
                    id="smallerThanUnidadesRecibidas"
                    value={formData.smallerThanUnidadesRecibidas}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          value: e.target.value,
                          id: "smallerThanUnidadesRecibidas",
                        },
                      })
                    }
                  />
                </div>
              </div>
            )}

            {selectedOptions.includes("greaterThanUnidadesRecibidas") && (
              <div className="form-group row">
                <div className="col">
                  <label htmlFor="greaterThanUnidadesRecibidas">
                    Unidades recibidas Mayor que:
                  </label>
                  <input
                    type="number"
                    className="form-control mb-4"
                    id="greaterThanUnidadesRecibidas"
                    value={formData.greaterThanUnidadesRecibidas}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          value: e.target.value,
                          id: "greaterThanUnidadesRecibidas",
                        },
                      })
                    }
                  />
                </div>
              </div>
            )}

            {selectedOptions.includes("smallerThanUnidadesDefectuosas") && (
              <div className="form-group row">
                <div className="col">
                  <label htmlFor="smallerThanUnidadesDefectuosas">
                    Unidades defectuosas Menor que:
                  </label>
                  <input
                    type="number"
                    className="form-control mb-4"
                    id="smallerThanUnidadesDefectuosas"
                    value={formData.smallerThanUnidadesDefectuosas}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          value: e.target.value,
                          id: "smallerThanUnidadesDefectuosas",
                        },
                      })
                    }
                  />
                </div>
              </div>
            )}

            {selectedOptions.includes("greaterThanUnidadesDefectuosas") && (
              <div className="form-group row">
                <div className="col">
                  <label htmlFor="greaterThanUnidadesDefectuosas">
                    Unidades defectuosas Mayor que:
                  </label>
                  <input
                    type="number"
                    className="form-control mb-4"
                    id="greaterThanUnidadesDefectuosas"
                    value={formData.greaterThanUnidadesDefectuosas}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          value: e.target.value,
                          id: "greaterThanUnidadesDefectuosas",
                        },
                      })
                    }
                  />
                </div>
              </div>
            )}
          </>
        )}

        {origin === "DOCUMENT" && (
          <>
            {selectedOptions.includes("selectedReceipt") && (
              <div className="form-group row mb-4">
                <div className="col">
                  <label htmlFor="selectedReceipt">Hay una factura?:</label>
                  <Select
                    placeholder="Seleccione una opción"
                    id="selectedReceipt"
                    options={stateDocumentOptions}
                    value={stateDocumentOptions.find(
                      (option) => option.value === formData.selectedReceipt
                    )}
                    onChange={(selectedOption) =>
                      handleChange({
                        target: {
                          value: selectedOption.value,
                          id: "selectedReceipt",
                        },
                      })
                    }
                  />
                </div>
              </div>
            )}

            {selectedOptions.includes("selectedRemission") && (
              <div className="form-group row mb-4">
                <div className="col">
                  <label htmlFor="selectedRemission">Hay una remisión?:</label>
                  <Select
                    placeholder="Seleccione una opción"
                    id="selectedReceipt"
                    options={stateDocumentOptions}
                    value={stateDocumentOptions.find(
                      (option) => option.value === formData.selectedRemission
                    )}
                    onChange={(selectedOption) =>
                      handleChange({
                        target: {
                          value: selectedOption.value,
                          id: "selectedRemission",
                        },
                      })
                    }
                  />
                </div>
              </div>
            )}

            {selectedOptions.includes("selectedQualityCertificate") && (
              <div className="form-group row mb-4">
                <div className="col">
                  <label htmlFor="selectedQualityCertificate">
                    Hay un Certificado de Calidad?:
                  </label>
                  <Select
                    placeholder="Seleccione una opción"
                    id="selectedQualityCertificate"
                    options={stateDocumentOptions}
                    value={stateDocumentOptions.find(
                      (option) =>
                        option.value === formData.selectedQualityCertificate
                    )}
                    onChange={(selectedOption) =>
                      handleChange({
                        target: {
                          value: selectedOption.value,
                          id: "selectedQualityCertificate",
                        },
                      })
                    }
                  />
                </div>
              </div>
            )}

            {selectedOptions.includes("selectedSafetySheet") && (
              <div className="form-group row mb-4">
                <div className="col">
                  <label htmlFor="selectedSafetySheet">
                    Hay una Hoja de Seguridad?:
                  </label>
                  <Select
                    placeholder="Seleccione una opción"
                    id="selectedSafetySheet"
                    options={stateDocumentOptions}
                    value={stateDocumentOptions.find(
                      (option) => option.value === formData.selectedSafetySheet
                    )}
                    onChange={(selectedOption) =>
                      handleChange({
                        target: {
                          value: selectedOption.value,
                          id: "selectedSafetySheet",
                        },
                      })
                    }
                  />
                </div>
              </div>
            )}

            {selectedOptions.includes("smallerThanPorcentajeDoc") && (
              <div>
                <div className="form-group row">
                  <div className="col">
                    <label htmlFor="smallerThanPorcentajeDoc">Porcentaje de documentos Menor que:</label>
                    <input
                      type="number"
                      className="form-control mb-4"
                      id="smallerThanPorcentajeDoc"
                      value={formData.smallerThanPorcentajeDoc}
                      onChange={(e) =>
                        handleChange({
                          target: {
                            value: e.target.value,
                            id: "smallerThanPorcentajeDoc",
                          },
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            )}

            {selectedOptions.includes("greaterThanPorcentajeDoc") && (
              <div>
                <div className="form-group row">
                  <div className="col">
                    <label htmlFor="greaterThanPorcentajeDoc">Porcentaje de documentos Mayor que:</label>
                    <input
                      type="number"
                      className="form-control mb-4"
                      id="greaterThanPorcentajeDoc"
                      value={formData.greaterThanPorcentajeDoc}
                      onChange={(e) =>
                        handleChange({
                          target: {
                            value: e.target.value,
                            id: "greaterThanPorcentajeDoc",
                          },
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {origin === "PROVIDER_INVENTORY" && (
          <>
            {selectedOptions.includes("selectedProviders") && (
              <div className="form-group row mb-4">
                <div className="col">
                  <label htmlFor="selectedProviders">Seleccionar Proveedores:</label>
                  <Select
                    id="selectedProviders"
                    placeholder="Seleccione Proveedores"
                    options={providerSelect}
                    isMulti
                    value={providerSelect.filter((option) =>
                      formData.selectedProviders?.includes(option.value)
                    )}
                    onChange={(selectedOptions) =>
                      handleChange({
                        target: {
                          value: selectedOptions.map((o) => o.value),
                          id: "selectedProviders",
                        },
                      })
                    }
                  />
                </div>
              </div>
            )}

            {selectedOptions.includes("onlyActive") && (
              <div className="form-group row mb-4">
                <div className="col">
                  <label htmlFor="onlyActive">Filtrar solo SKUs Activos:</label>
                  <Select
                    id="onlyActive"
                    options={[
                      { value: true, label: "Sí" },
                      { value: false, label: "No" },
                    ]}
                    value={{
                      value: formData.onlyActive,
                      label: formData.onlyActive ? "Sí" : "No",
                    }}
                    onChange={(selectedOption) =>
                      handleChange({
                        target: {
                          value: selectedOption.value,
                          id: "onlyActive",
                        },
                      })
                    }
                  />
                </div>
              </div>
            )}
          </>
        )}

        <div className="modal-footer justify-content-center align-items-center">
          <CDBBtn
            type="button"
            color="danger"
            outline
            onClick={() => setPressedButton("closeModal")}
          >
            Cerrar
          </CDBBtn>
          <CDBBtn
            type="submit"
            color="success"
            className="mr-auto"
            outline
            onClick={() => setPressedButton("submitModal")}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <CDBSpinner color="white" size="small" />{" "}
                <div>{isCreateAction ? "Guardar" : "Enviar"}</div>
              </>
            ) : isCreateAction ? (
              "Guardar"
            ) : (
              "Enviar"
            )}
          </CDBBtn>
        </div>
      </div>
    </div>
  );
};